import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining > 0 ? remaining : 86369;
    }
    const end = Date.now() + 86369 * 1000;
    sessionStorage.setItem('countdown_end', end.toString());
    return 86369;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          const end = Date.now() + 86369 * 1000;
          sessionStorage.setItem('countdown_end', end.toString());
          return 86369;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="text-center min-h-[100px] md:min-h-[120px]" data-id="element-38">
      <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-39">
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px] shadow-lg" data-id="element-40">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums will-change-contents" data-id="element-41">
            {pad(hours)}
          </span>
          <p className="text-xs mt-1 font-bold tracking-wider opacity-90 uppercase" data-id="element-42">
            hs
          </p>
        </div>
        <span className="text-3xl md:text-5xl font-black text-red-600" data-id="element-43">:</span>
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px] shadow-lg" data-id="element-44">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums will-change-contents" data-id="element-45">
            {pad(minutes)}
          </span>
          <p className="text-xs mt-1 font-bold tracking-wider opacity-90 uppercase" data-id="element-46">
            min
          </p>
        </div>
        <span className="text-3xl md:text-5xl font-black text-red-600" data-id="element-47">:</span>
        <div className="bg-red-600 text-white rounded-lg px-4 py-3 min-w-[70px] md:min-w-[90px] shadow-lg" data-id="element-48">
          <span className="text-3xl md:text-5xl font-heading font-black tabular-nums will-change-contents" data-id="element-49">
            {pad(seconds)}
          </span>
          <p className="text-xs mt-1 font-bold tracking-wider opacity-90 uppercase" data-id="element-50">
            seg
          </p>
        </div>
      </div>
    </div>;
}